import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const item = styled.div<{ $isDragging: boolean }>`
	width: 100%;
	height: 200px;
	padding: 1rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	border-radius: 5px;
	background-color: ${(props) =>
		props.$isDragging ? 'lightgreen' : color.interface.lightGray4};
	-webkit-box-shadow: 4px 3px 8px -7px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 4px 3px 8px -7px rgba(0, 0, 0, 0.75);
	box-shadow: 4px 3px 8px -7px rgba(0, 0, 0, 0.75);
`;

export const information = styled.div`
	position: absolute;
	display: none;
	width: 200px;
	right: 150%;
	background-color: ${color.interface.white};
	border: 1px solid ${color.interface.lightGray};
	border-radius: 5px;
	padding: 1rem;
`;

export const titleItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;

	> p {
		color: ${color.interface.darkgray};
		opacity: 0.8;
		font-size: 1.4rem;
		font-weight: 900;
	}

	> div {
		position: relative;

		> svg {
			color: ${color.interface.darkgray};
			opacity: 0.8;
			font-size: 2.5rem;
			cursor: help;
		}
	}
`;

export const imageMod = styled.div<{ $imgSrc: string }>`
	width: 100%;
	height: 100%;
	background-image: url(${(props) => props.$imgSrc});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
`;
